// src/colors.js
export const NAVY = "#2F4E8B";
export const NAVY_LIGHT = "#4a6bad";
export const OUTLINE = "#D4D9E0";
export const LABEL_GREY = "#4F5565";
export const CARD_BG = "#eaf1fb";
export const BLUE = "#2196F3";

export const GREY_BASE = "#90A4AE";
export const GREY_ICON = "#455A64";
export const GREY_LABEL = "#37474F";
export const GREY_BORDER_BASE = "#455A64";

export const ACCENTS = {
  users: { from: "#5B8DEF", to: "#3C6EEB" },
  leaves: { from: "#FFB74D", to: "#FF7043" },
  cra: { from: "#BA68C8", to: "#8E24AA" },
  telework: { from: "#26C6DA", to: "#00B8D4" },
};

export const PLAN_COLORS = {
  free: NAVY,
  one: "#6AB7FF",
  light: "#2E7D32",
  premium: "#f6a72f",
  gold: "#C8A200",
};

export const SELECTED_BORDER = "#ff0000";
export const CTA_ORANGE = "#f5a623";
export const CTA_ORANGE_HOVER = "#e89617";

export const STATUS_COLORS = {
  accepted: "#4CAF50",
  pending: "#F2B705",
  declined: "#ea4646",
  refused: "#ea4646",
  cancelled: NAVY,
  draft: "#888888",
};

export const STATUS_DOT_COLORS = {
  accepted: "#4CAF50",
  pending: "#F2B705",
  declined: "#ea4646",
  refused: "#ea4646",
  cancelled: NAVY,
  draft: "#888888",
};
